// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Option from "../../../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Api from "@react-google-maps/api";

function getGoogleConfig(config) {
  return {
          position: config.position,
          mapPaneName: Belt_Option.getWithDefault(config.mapPaneName, "markerLayer"),
          getPixelPositionOffset: config.getPixelPositionOffset,
          wrappedChildren: config.wrappedChildren,
          ref: config.ref
        };
}

function OverlayComponentMod(Props) {
  var lib_nameOpt = Props.lib_name;
  var config = Props.config;
  var lib_name = lib_nameOpt !== undefined ? lib_nameOpt : /* GoogleMap */0;
  if (lib_name) {
    return null;
  }
  var googleConfig = getGoogleConfig(config);
  return React.createElement(Api.OverlayView, {
              position: googleConfig.position,
              mapPaneName: googleConfig.mapPaneName,
              getPixelPositionOffset: googleConfig.getPixelPositionOffset,
              children: googleConfig.wrappedChildren
            });
}

var make = OverlayComponentMod;

export {
  getGoogleConfig ,
  make ,
  
}
/* react Not a pure module */
